import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import CartransferDetailsForm from "./CartransferDetailsForm";
import { getCartransfer } from "../../../api/cartransferService";

const CartransferDetails = ({ cartransferId }) => {
  //right now I will do it by cartransferId but I could be by a simplier format.
  const [cartransfer, setCartransfer] = useState();

  useEffect(() => {
    const fetchCartransfer = async () => {
      const response = await getCartransfer(cartransferId);
      setCartransfer(response.data);
    };
    fetchCartransfer();
  }, [cartransferId]);
  //"public" url to show what the QR code returns from pdf
  //still needs for login but I wont show the admin panel
  //need to modify the backend to all registered users to have permission to see this but not the other stuff

  if (!cartransfer) {
    return <Spin />;
  }

  return (
    <div style={{ padding: 10 }}>
      <CartransferDetailsForm cartransfer={cartransfer} />;
    </div>
  );
};

export default CartransferDetails;
